import React from "react";
import {connect} from "react-redux";
import {Link} from "react-router-dom";

import {closeGuide} from "state/teachers/actions";
import {isGuideOpen} from "state/teachers/selectors";

import WelcomeGuide from "components/WelcomeGuide";

import logoWithText from "components/assets/images/teachers/teachers-logo--text-right.svg";
import logoWithoutText from "components/assets/images/teachers/teachers-logo--no-text.svg";
import termCalendarIcon from "components/assets/images/teachers/guide/term-calendar.svg";
import messagesIcon from "components/assets/images/teachers/guide/messages.svg";
import noticeboardIcon from "components/assets/images/teachers/guide/noticeboard.svg";
import multiSchoolSupportIcon from "components/assets/images/teachers/guide/multi-school-support.svg";
import verificationIcon from "components/assets/images/teachers/guide/verification.svg";
import faqIcon from "components/assets/images/teachers/guide/faq.svg";

import "./Guide.css";

class Guide extends React.Component {

  guideChildren = [
    <div className="teachers-guide-page" key="welcome">
      <div className="teachers-guide-page__icon">
        <img src={logoWithoutText} alt="Teachers2Parents" />
      </div>
      <div className="teachers-guide-page__body">
        <h1>Welcome!</h1>
        <p>The Teachers2Parents app allows you to see all the messages that are sent to you from your child’s school as well as any notices that they might have posted to announce or remind you of upcoming events. A term calendar is also available to you, so that you can easily keep track of any notable dates.</p>
      </div>
    </div>,

    <div className="teachers-guide-page" key="messages">
      <div className="teachers-guide-page__icon"><img src={messagesIcon} alt="Messages" /></div>
      <div className="teachers-guide-page__body">
        <h1>Messages</h1>
        <p>The messages section allows you to read any messages that have been sent to you from your child’s school.</p>
        <p>Any new messages will appear at the bottom of the screen; you will also be able to scroll up to see any previous messages you have received.</p>
      </div>
    </div>,

    <div className="teachers-guide-page" key="noticeboard">
      <div className="teachers-guide-page__icon"><img src={noticeboardIcon} alt="Noticeboard" /></div>
      <div className="teachers-guide-page__body">
        <h1>Noticeboard</h1>
        <p>In the Noticeboard section, you will be able to see any additional information or news updates that the school has posted. This could include any upcoming events or any general announcements that you might need to know about.</p>
        <p>The school may send you notifications about some of these events or announcements to make sure that you are kept fully up-to-date.</p>
      </div>
    </div>,

    <div className="teachers-guide-page" key="term_calendar">
      <div className="teachers-guide-page__icon"><img src={termCalendarIcon} alt="Term Calendar" /></div>
      <div className="teachers-guide-page__body">
        <h1>Term Calendar</h1>
        <p>Schools can add their term dates to the Term Calendar so you always have them handy!</p>
      </div>
    </div>,

    <div className="teachers-guide-page" key="multi_school_support">
      <div className="teachers-guide-page__icon"><img src={multiSchoolSupportIcon} alt="Multiple School Support" /></div>
      <div className="teachers-guide-page__body">
        <h1>Multi-School Support</h1>
        <p>If you have children at multiple schools that use the Teachers2Parents service, you can switch between schools with the school selector in each section of the app.</p>
      </div>
    </div>,

    <div className="teachers-guide-page" key="built_in_verification">
      <div className="teachers-guide-page__icon"><img src={verificationIcon} alt="No Need for Message Verification" /></div>
      <div className="teachers-guide-page__body">
        <h1>Built-in Verification</h1>
        <p>With our end to end encrypted messages, there is no need to verify the messages you receive.</p>
      </div>
    </div>,

    <div className="teachers-guide-page" key="faq">
      <div className="teachers-guide-page__icon"><img src={faqIcon} alt="FAQ" /></div>
      <div className="teachers-guide-page__body">
        <h1>FAQ</h1>
        <p><Link to="/help/" onClick={this.props.closeGuide}>Click Here</Link> to view our FAQs on why we have your phone number and what Teachers2Parents &amp; Eduspot are.</p>
      </div>
    </div>
  ]
  
  onClose = () => {
    this.props.closeGuide();
  }
  
  render() {
    const { isOpen, close } = this.props;
      return (
        <WelcomeGuide cssModifier="teachers" logoPath={logoWithText} isOpen={isOpen} onClose={close}>
          { this.guideChildren }
        </WelcomeGuide>
      );
  }
}

export default connect (
  (state) => ({
    isOpen: isGuideOpen(state)
  }),
  { close: closeGuide }
)(Guide)



// WEBPACK FOOTER //
// ./src/components/teachers/guide/Guide.js